<template>
  <div>
    <v-dialog
      v-model="showPostOpportunityCampaignDialog"
      :retain-focus="false"
      :max-width="500"
      transition="slide-y-transition"
      @click:outside="hideModal"
    >
      <v-card
        class="pa-2 pt-0 pb-0"
        :style="contentStyle"
      >
        <v-container>
          <v-row
            no-gutters
            align="center"
          >
            <v-col class="headline">
              Post an opportunity to earn 100 €/£!*
            </v-col>

            <v-col cols="auto">
              <v-btn
                small
                fab
                icon
                @click="hideModal"
              >
                <v-icon>
                  close
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>

          <v-row
            class="my-4"
            no-gutters
          >
            <v-col cols="12">
              <p>
                Earn 100 €/£ when you post a job opportunity on our platform. We’ll support you by sourcing high quality applications from our curated network of independents.
              </p>
              <p class="mt-2">
                <i>*Valid only until 30th September</i>
              </p>
              <v-img
                class="mx-auto my-5"
                :src="require('@/assets/images/ui/Platform-popup-100.svg')"
                max-width="50%"
                contain
              />
              <div class="text-center">
                <v-btn
                  class="mt-3"
                  color="primary"
                  rounded
                  light
                  @click="handlePostOppClick"
                >
                  Post an opportunity now
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showCreateDialog"
      fullscreen
      persistent
      transition="dialog-bottom-transition-10"
    >
      <createOpportunity
        @hide="showCreateDialog = false"
        @submitOpp="submitOpp"
      />
    </v-dialog>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

import InfoDialog from '@/components/core/InfoDialog.vue'
import createOpportunity from '@/components/opportunities/createOpportunity.vue'
import { waitAsync } from '@/utils/common'
import { MODAL_TRANSITION_TIME, PURPLE_BG_GRADIENT_TOP } from '@/constants'
import { postOppCampaignEvents } from '@/segmentAnalytics/dashboard'

@Component({
  components: {
    InfoDialog,
    createOpportunity
  },
  computed: {
    ...mapGetters(['showPostOpportunityCampaignDialog'])
  }
})
export default class PostOpportunityCampaignDialog extends Vue {
  showCreateDialog: boolean = false
  contentStyle = PURPLE_BG_GRADIENT_TOP

  showPostOpportunityCampaignDialog: boolean

  async submitOpp (input: any) {
    this.showCreateDialog = false
    await waitAsync(MODAL_TRANSITION_TIME)
    this.$store.dispatch('upsertOpportunity', input)
  }

  hideModal () {
    postOppCampaignEvents.trackClose()
    this.$store.commit('hidePostOpportunityCampaignDialog')
  }

  handlePostOppClick () {
    postOppCampaignEvents.trackPostJobClick()
    this.showCreateDialog = true
  }
}
</script>
